module.exports = __webpack_public_path__ + "img/cinema_2.1772668e.jpg";